import * as appsettings from "./appsettings";
import * as main from "./main";
import * as navigation from "./navigation";
import * as session from "./session";
import { TimeIntervalEnum as timeIntervalEnum } from "./enums/timeIntervalEnum";

let exportFlag = false;

let LABEL_ENoDataFound = "";

const defaultGridOptions: { [key: string]: string } = {};

const hasNoDefault: { [key: string]: boolean } = {};

//
// Template for boolean columns.
// Will show check mark when true.
//
export function booleanTemplate(data: boolean): string {

    let image = "";

    if (data) {
        image = appsettings.getUrl('images/svg/Check.svg');
    }
    else {
        image = appsettings.getUrl('images/svg/Multiply.svg');
    }

    return "<div style='text-align: center;'><img src=" + image + " style = 'width:21px; height:21px;'></div>";
}

export function booleanTemplateWInverse(data: boolean, inverse: boolean): string {
    let htmTempl = "";

    if (data != null) {
        let showBool = data;

        if (inverse !== undefined && inverse) {
            showBool = !showBool;
        }

        if (showBool) {
            htmTempl = "<div style='text-align: center;'><span class='k-icon k-font-icon k-i-checkmark-circle' style='color: green;'></span></div>";
        }
        else {
            htmTempl = "<div style='text-align: center;'><span class='k-icon k-font-icon k-i-x-circle' style='color: red;'></span></div>";
        }
    }

    return htmTempl;
}

export function dateTimeTemplate(data: string): string {
    let result = "";

    if (data) {
        result = kendo.toString(kendo.parseDate(data), 'G');
    }

    return result;
}

//
// Exports all defined columns in the grid even if they are hidden.
// https://www.telerik.com/forums/exporting-all-the-columns-to-excel
//
export function exportExcellAllFields(e: any) {

    let sheet = e.workbook.sheets[0];
    let data = e.data;
    let gridColumns = e.sender.columns;
    let columns = gridColumns.map(function (col: any) {
        return {
            value: col.title ? col.title : col.field,
            autoWidth: true,
            background: "#7a7a7a",
            color: "#fff"
        };
    });

    let rows = [{ cells: columns, type: "header" }];

    for (let i = 0; i < data.length; i++) {
        let rowCells = [];
        for (let j = 0; j < gridColumns.length; j++) {
            let cellValue = data[i][gridColumns[j].field];
            rowCells.push({ value: cellValue });
        }
        rows.push({ cells: rowCells, type: "data" });
    }
    sheet.rows = rows;
}


//
// Exports all defined columns in the grid even if they are hidden.
// Temporarily sets hidden columns to show and back.
// https://docs.telerik.com/kendo-ui/knowledge-base/grid-include-hidden-columns-to-exported-pdf
//
export function exportPdfAllFields(e: any) {

    if (!exportFlag) {

        const gridColumns = e.sender.columns;
        let hiddenArr: any[] = [];

        for (let i = 0; i < gridColumns.length; i++) {
            if (gridColumns[i].hidden) {
                hiddenArr.push(i);
                e.sender.showColumn(i);
            }
        }

        e.preventDefault();
        exportFlag = true;

        e.sender.saveAsPDF().then(function () {
            for (var i = 0; i < hiddenArr.length; i++) {
                e.sender.hideColumn(hiddenArr[i]);
            }
            exportFlag = false;
        });
    }
}

export function initializeToolbar(): void {
    $(".precom-export-menu").each(function (): void {
        const menu = $(this);

        if (menu.data("kendoMenu") == undefined) {
            menu.kendoMenu({
                openOnClick: true
            });
        }
    });

    $(".k-toolbar").css("overflow", "visible");
}

/**
 * Init (binding button actions) Overview grid
 */
export function initialize(gridId: string, addUrl: string): void {
    $(document)
        .off("click.overviewAdd", "#" + gridId + " .k-grid-add")
        .on("click.overviewAdd", "#" + gridId + " .k-grid-add", function (e: JQuery.Event): void {
            e.preventDefault();
            // Load create form into the current module div
            navigation.navigateToSpecificUrl(addUrl);
        });

    initializeToolbar();
    loadGridOptions(gridId);
}

function getDefaultKey(gridId: string): string {
    return "kendo-grid-default-" + gridId + "-" + session.getMyUserId();
}

function removeCommandOptions(columns: any[]): void {
    if (!columns) {
        return;
    }

    for (let i = 0; i < columns.length; i++) {
        const column = columns[i];

        if (column?.command) {
            delete column.command;
        }

        if (column?.columns) {
            removeCommandOptions(column.columns);
        }
    }
}

function restoreCommandOptions(currentColumns: any[], savedColumns: any[]): void {
    if (!currentColumns || !savedColumns) {
        return;
    }

    const length = Math.min(currentColumns.length, savedColumns.length);

    for (let i = 0; i < length; i++) {
        const currentColumn = currentColumns[i];
        const savedColumn = savedColumns[i];

        if (currentColumn?.command && !savedColumn?.command) {
            savedColumn.command = currentColumn.command;
        }

        if (currentColumn?.columns && savedColumn?.columns) {
            restoreCommandOptions(currentColumn.columns, savedColumn.columns);
        }
    }
}

interface GridState {
    filter?: kendo.data.DataSourceFilters;
    sort?: kendo.data.DataSourceSortItem[];
    columns?: any[];
}

export function saveGridOptions(e): void {
    var gridId = e.sender.element.attr("id");
    var key = "kendo-grid-options-" + gridId + "-" + session.getMyUserId();
    var searchKey = "kendo-grid-search-" + gridId + "-" + session.getMyUserId();
    var grid = $("#" + gridId).data("kendoGrid");

    if (grid == undefined) {
        return;
    }

    const dataSource = grid.dataSource;
    const state: GridState = {
        filter: dataSource.filter(),
        sort: dataSource.sort(),
        columns: grid.columns
    };
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key, serializedState);

    const searchValue = grid.element.find(".k-grid-search input").val();

    if (searchValue != null && searchValue !== "") {
        localStorage[searchKey] = searchValue;
    }
    else {
        localStorage.removeItem(searchKey);
    }

    const defaultKey = getDefaultKey(gridId);

    // Save the default when there is no default for the grid saved
    if (hasNoDefault[defaultKey]) {
        defaultGridOptions[defaultKey] = serializedState;
        delete hasNoDefault[defaultKey];
        localStorage.removeItem(key);
        return;
    }

    const defaultOptions = defaultGridOptions[defaultKey];

    if (defaultOptions !== undefined && serializedState === defaultOptions) {
        localStorage.removeItem(key);
    }
    else {
        localStorage[key] = serializedState;
    }
}

export function loadGridOptions(gridId: string): void {
    var key = "kendo-grid-options-" + gridId + "-" + session.getMyUserId();
    var searchKey = "kendo-grid-search-" + gridId + "-" + session.getMyUserId();
    var grid = $("#" + gridId).data("kendoGrid");

    if (grid == undefined) {
        return;
    }

    // Check if grid has no options
    if (!localStorage[key]) {
        hasNoDefault[getDefaultKey(gridId)] = true;
    }

    const searchValue = localStorage[searchKey];

    if (searchValue) {
        const searchInput = grid.element.find(".k-grid-search input");

        if (searchInput.length > 0) {
            searchInput.val(searchValue);
            searchInput.trigger("input").trigger("keyup");
        }
    }

    const raw = localStorage.getItem(key);
    if (!raw) return;

    const state: GridState = JSON.parse(raw);

    if (state.columns) {
        // reorder + hide/show
        state.columns.forEach((col, index) => {
            if (col.hidden) {
                grid.hideColumn(col.field);
            } else {
                grid.showColumn(col.field);
            }
        });
    }

    if (state.filter) {
        grid.dataSource.filter(state.filter);
    }
    if (state.sort) {
        grid.dataSource.sort(state.sort);
    }
}

export function setLabel(ENoDataFound: string): void {
    LABEL_ENoDataFound = ENoDataFound
}

export function onDataBound(e: kendo.ui.GridDataBoundEvent): void {
    $("#SearchButtonLoader").hide();

    if (e.sender.dataSource.view().length < 1) {
        main.setHideDiv("DivGridMsg", true);
        var lblEmsg = $("#LblGridMsg");
        if (lblEmsg != null && lblEmsg != undefined) {
            lblEmsg.text(LABEL_ENoDataFound);
        }
    }
    saveGridOptions(e);
}

export function onChangeTimeInterval(e: kendo.ui.DropDownListChangeEvent): void {
    const show = e.sender.value() == timeIntervalEnum.AskedPeriod.toString();
    main.setHideDivBootstrap("periodSelector", show);
}
